/* ============================================================================
   KALKI AI Stylist - widget logic (July 2026)
   Extracted from snippets/kalki-chat.liquid (loaded with `defer`). All
   dynamic data (customer, product context) is read from the JSON script
   tags the snippet renders - there is NO Liquid in this file. Edit HERE,
   not in the snippet.
   ============================================================================ */
(function() {
  'use strict';

  console.log('🚀 KALKI AI Chat Widget Initializing...');

  const API_URL = 'https://api.kalkifashion.com/kalki-chat/chat-api.php';

  // ─────────────────────────────────────────────────────────────────────
  // NUDGE ENGINE CONFIG
  //
  // tryOnTag: STRICT match (updated June 2026). Previously the matcher
  //   did loose substring matching across an array of related tags
  //   ('vto', 'tryon', 'virtual-try-on', etc.) which made it impossible
  //   for merchandisers to opt a product OUT of the Store Trial nudge
  //   without changing every tag on the product. Now the matcher only
  //   triggers when the product has the EXACT tag 'try-on' (case-
  //   insensitive). Add the tag in Shopify Admin -> Products -> Tags to
  //   enable the Store Trial nudge for that product.
  // ─────────────────────────────────────────────────────────────────────
  const NUDGE_CONFIG = {
    tryOnTag: 'try-on',
    showDelayMs: 4000,
    dismissAfterMs: 60000,
    sessionDismissKey: 'kalki_nudge_dismissed',
  };

  // ─────────────────────────────────────────────────────────────────────
  // HANDS-FREE CONVERSATION CONFIG
  //
  // autoListenDelayMs: REDUCED June 2026 from 1000ms -> 200ms
  //   The original 1-second pause after TTS ended (before reopening
  //   the mic) was added defensively to prevent the mic from capturing
  //   the bot's own audio tail. But getUserMedia is called with
  //   echoCancellation:true, which the browser handles natively, so
  //   the 1s pause was making voice mode feel sluggish — customers
  //   experienced "dead air" between Aara finishing her sentence and
  //   the listening indicator appearing. 200ms is enough to debounce
  //   the audio.ended event without feeling like a wait.
  // ─────────────────────────────────────────────────────────────────────
  const HANDS_FREE_CONFIG = {
    cloudTtsUrl: 'https://api.kalkifashion.com/kalki-chat/voice-synthesize.php',
    cloudTtsVoice: 'en-IN-Wavenet-A',
    cloudTtsLanguage: 'en-IN',
    ttsLangPrimary: 'en-IN',
    ttsRate: 1.0,
    ttsPitch: 1.0,
    silenceThreshold: 0.018,
    silenceTimeoutMs: 1300,
    maxRecordingMs: 15000,
    autoListenDelayMs: 200,
    ttsMaxChars: 400,
    minTranscriptChars: 2,
  };

  let handsFreeMode = false;
  let handsFreeSpeaking = false;
  let activeTtsAudio = null;
  let currentChatAbort = null;
  const handsFreeOps = {
    startListening: null,
    stopListening: null,
    isReady: false,
  };

  const pendingTagalysInits = [];
  function flushPendingTagalysInits() {
    while (pendingTagalysInits.length) {
      const fn = pendingTagalysInits.shift();
      requestAnimationFrame(() => requestAnimationFrame(fn));
    }
    [250, 700, 1400].forEach((ms) => {
      setTimeout(() => { try { window.dispatchEvent(new Event('resize')); } catch (e) {} }, ms);
    });
  }

  let loggedInCustomer = null;
  const customerDataEl = document.getElementById('kalki-customer-data');
  if (customerDataEl) {
    try {
      loggedInCustomer = JSON.parse(customerDataEl.textContent);
    } catch (e) {
      console.error('Failed to parse customer data:', e);
    }
  }

  let currentProduct = null;
  const productDataEl = document.getElementById('kalki-product-context');
  if (productDataEl) {
    try {
      currentProduct = JSON.parse(productDataEl.textContent);
    } catch (e) {
      console.error('Failed to parse product context:', e);
    }
  }

  let chatHistory = JSON.parse(localStorage.getItem('kalki_chat_history') || '[]');
  let sessionId = localStorage.getItem('kalki_session_id') || generateSessionId();
  let customerInfo = null;

  if (loggedInCustomer && loggedInCustomer.email) {
    const firstName = loggedInCustomer.first_name || '';
    const lastName = loggedInCustomer.last_name || '';
    const phone = loggedInCustomer.phone || (loggedInCustomer.default_address && loggedInCustomer.default_address.phone) || '';
    customerInfo = { name: (firstName + ' ' + lastName).trim(), email: loggedInCustomer.email, phone: phone };
    localStorage.setItem('kalki_customer_info', JSON.stringify(customerInfo));
  } else {
    customerInfo = JSON.parse(localStorage.getItem('kalki_customer_info') || 'null');
  }

  let isSending = false;
  let shownProductIds = JSON.parse(localStorage.getItem('kalki_shown_product_ids') || '[]');
  let lastSearch = JSON.parse(localStorage.getItem('kalki_last_search') || 'null');

  function rememberShownProducts(products) {
    if (!Array.isArray(products) || products.length === 0) return;
    const newIds = products.map(p => p && p.id).filter(id => id && Number.isFinite(Number(id)));
    if (newIds.length === 0) return;
    const merged = shownProductIds.concat(newIds);
    const seen = {};
    const deduped = [];
    for (const id of merged) {
      const n = Number(id);
      if (!seen[n]) { seen[n] = true; deduped.push(n); }
    }
    shownProductIds = deduped.slice(-200);
    localStorage.setItem('kalki_shown_product_ids', JSON.stringify(shownProductIds));
  }

  function rememberLastSearch(searchContext) {
    if (searchContext && typeof searchContext === 'object') {
      lastSearch = searchContext;
      localStorage.setItem('kalki_last_search', JSON.stringify(lastSearch));
    }
  }

  localStorage.setItem('kalki_session_id', sessionId);

  const toggle = document.getElementById('kalki-chat-toggle');
  const chatWindow = document.getElementById('kalki-chat-window');
  const messages = document.getElementById('kalki-chat-messages');
  const input = document.getElementById('kalki-chat-input');
  const sendBtn = document.getElementById('kalki-chat-send');
  const iconOpen = document.getElementById('kalki-chat-icon-open');
  const iconClose = document.getElementById('kalki-chat-icon-close');
  function setChatOpen(open) {
    if (chatWindow) chatWindow.style.display = open ? 'flex' : 'none';
    if (iconOpen)  iconOpen.style.display  = open ? 'none' : 'block';
    if (iconClose) iconClose.style.display = open ? 'block' : 'none';
  }

  initializeChat();
  scheduleNudge();

  function initializeChat() {
    if (!customerInfo) {
      showWelcomeAndForm();
    } else {
      if (chatHistory.length > 0) {
        restoreChatHistory();
      } else {
        const firstName = customerInfo.name.split(' ')[0];
        addMessage('Welcome back, ' + firstName + '! 😊 How can I help you today?', 'bot');
      }
    }
  }

  // ─────────────────────────────────────────────────────────────────────
  // NUDGE ENGINE
  //
  // After a 4-second delay on product pages, show a contextual prompt
  // bubble next to the chat toggle. The bubble auto-dismisses after 60s
  // and is silenced for the session if the customer closes it.
  // ─────────────────────────────────────────────────────────────────────
  function scheduleNudge() {
    try {
      if (sessionStorage.getItem(NUDGE_CONFIG.sessionDismissKey) === '1') return;
    } catch (e) {}
    if (!currentProduct) return;
    const nudgeContent = pickNudgeContent();
    if (!nudgeContent) return;
    setTimeout(() => {
      if (chatWindow.style.display === 'flex') return;
      showNudge(nudgeContent);
    }, NUDGE_CONFIG.showDelayMs);
  }

  // ─────────────────────────────────────────────────────────────────────
  // PRODUCT-TYPE-AWARE NUDGE PICKER (updated June 2026)
  //
  // Tailors Aara's opening line based on what the customer is looking at.
  // The product.type field comes from Shopify and is set per product, so
  // we match against a few canonical names. If none match, fall through
  // to a warm default. Try-on products take priority since they unlock
  // the virtual try-on flow which is the highest-value path.
  //
  // Categories:
  //   styleHelpers - drape-and-occasion stuff (sarees, lehengas, gowns)
  //     -> "Want me to help you style this?"
  //   lookBuilders - separates that need a top/bottom/accessory pairing
  //     -> "Want me to complete the look for you?"
  //   accessoryTypes - jewellery, dupatta, clutch etc. - drive outfit
  //     pairing from the accessory back out to a full look
  //     -> "Want me to suggest outfits that pair with this?"
  // ─────────────────────────────────────────────────────────────────────
  function pickNudgeContent() {
    if (!currentProduct) return null;

    if (hasTryOnTag(currentProduct.tags)) {
      return {
        icon: '✨',
        text: 'Stunning pick! Want to use Store Trial and see how this looks on you?',
        // action='vto' tells the nudge click handler to bypass chat and
        // fire the page-level VTO button directly. prefill is kept as a
        // fallback in case #kalki-vto-trigger-btn isn't on the page.
        action: 'vto',
        prefill: 'I\'d like to use Store Trial for this outfit',
      };
    }

    const ptype = String(currentProduct.type || '').toLowerCase();
    const styleHelpers   = ['saree', 'sari', 'lehenga', 'gown', 'anarkali', 'sharara', 'gharara'];
    const lookBuilders   = ['salwar kameez', 'kurta', 'kurti', 'palazzo', 'co-ord'];
    const accessoryTypes = ['jewellery', 'jewelry', 'dupatta', 'clutch', 'potli'];
    const matches = (list) => list.some(t => ptype.indexOf(t) !== -1);

    if (matches(styleHelpers)) {
      return {
        icon: '😍',
        text: 'Oh, amazing choice! Want me to help you style this?',
        prefill: 'Help me style this — what would go with it?',
      };
    }

    if (matches(lookBuilders)) {
      return {
        icon: '✨',
        text: 'Gorgeous pick! Want me to complete the look for you?',
        prefill: 'Help me complete the look with this',
      };
    }

    if (matches(accessoryTypes)) {
      return {
        icon: '💫',
        text: 'Love it! Want me to suggest outfits that pair with this?',
        prefill: 'What outfits would pair well with this?',
      };
    }

    return {
      icon: '😍',
      text: 'Beautiful choice! Want me to help you style this?',
      prefill: 'Help me style this',
    };
  }

  // STRICT try-on tag check (updated June 2026).
  //
  // Returns true only when the product has the EXACT tag 'try-on'
  // (case-insensitive, trimmed). Earlier versions did substring matching
  // across a list of related vocabulary ('vto', 'tryon', 'virtual-try-on',
  // 'try on') which produced false positives - a product tagged
  // 'no-try-on-allowed' or 'try-on-policy-link' would have matched.
  //
  // Merchandisers now control the Store Trial nudge by adding the literal
  // tag 'try-on' (no spaces, lowercase, hyphenated) in Shopify Admin.
  // Anything else gets the generic style/look nudge instead.
  function hasTryOnTag(tags) {
    if (!tags) return false;
    let tagArr = [];
    if (Array.isArray(tags)) tagArr = tags;
    else if (typeof tags === 'string') tagArr = tags.split(',').map(t => t.trim());
    else return false;
    const needle = NUDGE_CONFIG.tryOnTag.toLowerCase();
    return tagArr.some(t => String(t).trim().toLowerCase() === needle);
  }

  function showNudge(content) {
    if (document.getElementById('kalki-nudge')) return;
    const nudge = document.createElement('div');
    nudge.id = 'kalki-nudge';
    nudge.setAttribute('role', 'button');
    nudge.setAttribute('aria-label', content.text);
    nudge.innerHTML = '<button class="kalki-nudge-close" aria-label="Dismiss">✕</button><span class="kalki-nudge-icon">' + escapeHtml(content.icon) + '</span><span>' + escapeHtml(content.text) + '</span>';
    document.body.appendChild(nudge);
    requestAnimationFrame(() => nudge.classList.add('kalki-nudge-visible'));
    const dismissTimer = setTimeout(() => hideNudge(nudge, false), NUDGE_CONFIG.dismissAfterMs);
    nudge.addEventListener('click', (e) => {
      if (e.target && e.target.classList && e.target.classList.contains('kalki-nudge-close')) return;
      clearTimeout(dismissTimer);
      hideNudge(nudge, false);

      // Special action: Store Trial nudges fire the page-level VTO
      // button directly. No chat conversation needed since the customer
      // explicitly tapped a Store Trial CTA - going through chat would
      // just add friction. Falls back to chat-with-prefill if the VTO
      // button isn't found (e.g. if the Liquid snippet that renders it
      // isn't included on this template).
      if (content.action === 'vto') {
        if (triggerVtoAndCloseChat()) return;
        // Fallback: VTO button missing - open chat so Aara can help.
        openChatWithPrefill(content.prefill || 'I\'d like to use Store Trial');
        return;
      }

      // Click-to-Talk: tap on a nudge opens the chat AND activates the
      // hands-free voice mode so the customer can speak their reply
      // immediately - no typing required. This matches the "voice-first"
      // experience customers expect when they engage with an AI stylist.
      //
      // CRITICAL: startListening() must be called SYNCHRONOUSLY inside this
      // click handler (no setTimeout, no await before it). Browsers - especially
      // iOS Safari - only grant mic permission via getUserMedia when it's
      // invoked within an active user-gesture context. Breaking out into
      // setTimeout or any async boundary loses that gesture and the permission
      // prompt fails silently. The chat window opens via a CSS display change
      // which is instant, so no delay is needed.
      //
      // Falls back to text prefill if the mic infrastructure isn't ready
      // (e.g., MediaRecorder unsupported, hands-free button not rendered).
      if (handsFreeOps && handsFreeOps.isReady && handsFreeOps.startListening) {
        // Empty prefill so the customer's voice input isn't fighting any
        // prefilled placeholder text in the input field.
        openChatWithPrefill('');
        try {
          if (!handsFreeMode) {
            handsFreeMode = true;
            handsFreeOps.startListening();
            console.log('[KalkiChat] Click-to-Talk: hands-free activated from nudge tap');
          }
        } catch (err) {
          console.warn('[KalkiChat] Click-to-Talk failed, falling back to text prefill:', err);
          handsFreeMode = false;
          if (input) input.value = content.prefill || '';
        }
      } else {
        // No mic available - fall back to prefilled text the customer can edit
        console.log('[KalkiChat] Click-to-Talk: hands-free not ready, using text prefill');
        openChatWithPrefill(content.prefill);
      }
    });
    const closeBtn = nudge.querySelector('.kalki-nudge-close');
    if (closeBtn) {
      closeBtn.addEventListener('click', (e) => {
        e.stopPropagation();
        clearTimeout(dismissTimer);
        try { sessionStorage.setItem(NUDGE_CONFIG.sessionDismissKey, '1'); } catch (err) {}
        hideNudge(nudge, true);
      });
    }
  }

  function hideNudge(nudge, immediate) {
    if (!nudge || !nudge.parentNode) return;
    nudge.classList.remove('kalki-nudge-visible');
    setTimeout(() => { if (nudge.parentNode) nudge.parentNode.removeChild(nudge); }, immediate ? 50 : 400);
  }

  function openChatWithPrefill(text) {
    if (chatWindow.style.display !== 'flex') {
      setChatOpen(true);
      flushPendingTagalysInits();
    }
    if (input) {
      input.value = text || '';
      try { input.focus(); input.setSelectionRange(text.length, text.length); } catch (e) {}
    }
    setTimeout(() => { messages.scrollTop = messages.scrollHeight; }, 100);
  }

  // ─────────────────────────────────────────────────────────────────────
  // STORE TRIAL (VTO) LAUNCHER
  //
  // Clicks the page-level VTO trigger button (#kalki-vto-trigger-btn) and
  // closes the chat popup. Called from two places:
  //
  //   1. The Store Trial nudge bubble - tap directly bypasses chat and
  //      goes straight to the VTO experience. No conversation needed
  //      since the customer's intent was clear from tapping the CTA.
  //
  //   2. Inside chat, when Aara emits the [TRIGGER_VTO] marker tag in
  //      her reply. This lets the AI confirm intent in natural language
  //      ("Great! Launching Store Trial for you...") before the VTO
  //      experience takes over the screen.
  //
  // Returns true on success, false if the button doesn't exist on the
  // current page (defensive - caller can fall back to chat prefill).
  // Also stops hands-free voice mode if it's running, otherwise the
  // mic would stay live behind the VTO screen.
  // ─────────────────────────────────────────────────────────────────────
  function triggerVtoAndCloseChat() {
    const vtoBtn = document.getElementById('kalki-vto-trigger-btn');
    if (!vtoBtn) {
      console.warn('[KALKI] VTO trigger button (#kalki-vto-trigger-btn) not found on page');
      return false;
    }

    // Stop voice mode first - mic+TTS shouldn't keep running once the
    // VTO experience opens (privacy + battery).
    if (handsFreeMode) {
      handsFreeMode = false;
      if (handsFreeOps.stopListening) handsFreeOps.stopListening();
    }

    // Close the chat window
    if (chatWindow && chatWindow.style.display === 'flex') {
      setChatOpen(false);
    }

    // Click the page's VTO trigger
    try {
      vtoBtn.click();
      console.log('[KALKI] VTO trigger fired, chat closed');
      return true;
    } catch (e) {
      console.error('[KALKI] Failed to click VTO trigger:', e);
      return false;
    }
  }

  function showWelcomeAndForm() {
    const welcomeMsg = document.createElement('div');
    welcomeMsg.className = 'kalki-msg kalki-msg-bot';
    welcomeMsg.innerHTML = '<div class="kalki-msg-bubble">Welcome to KALKI Fashion! ✨ Please share your details so I can help you better!</div>';
    messages.appendChild(welcomeMsg);
    const formDiv = document.createElement('div');
    formDiv.className = 'kalki-contact-form-inline';
    formDiv.id = 'initial-contact-form';
    formDiv.innerHTML = '<h4>👋 Let\'s connect!</h4><p>Enter your details to start shopping</p><input type="text" id="contact-name" placeholder="Your Name *" required /><input type="email" id="contact-email" placeholder="Email Address *" required /><input type="tel" id="contact-phone" placeholder="Phone Number" /><div class="kalki-form-buttons"><button class="kalki-form-submit" id="contact-submit">Start Chat →</button></div>';
    messages.appendChild(formDiv);
    document.getElementById('contact-submit').addEventListener('click', submitContactForm);
    document.getElementById('contact-email').addEventListener('keydown', (e) => {
      if (e.key === 'Enter') { e.preventDefault(); submitContactForm(); }
    });
  }

  function submitContactForm() {
    const name = document.getElementById('contact-name').value.trim();
    const email = document.getElementById('contact-email').value.trim();
    const phone = document.getElementById('contact-phone').value.trim();
    if (!name) { alert('Please enter your name'); document.getElementById('contact-name').focus(); return; }
    if (!email) { alert('Please enter your email'); document.getElementById('contact-email').focus(); return; }
    if (!validateEmail(email)) { alert('Please enter a valid email address'); document.getElementById('contact-email').focus(); return; }
    customerInfo = { name: name, email: email, phone: phone };
    localStorage.setItem('kalki_customer_info', JSON.stringify(customerInfo));
    document.getElementById('initial-contact-form').remove();
    addMessage('Thank you, ' + name + '! 😊 I\'m here to help you find the perfect outfit. What are you looking for today?', 'bot');
    input.focus();
  }

  function restoreChatHistory() {
    chatHistory.forEach((msg) => {
      addMessage(
        msg.content,
        msg.role === 'assistant' ? 'bot' : 'user',
        msg.products || [],
        msg.orders || [],
        msg.see_all_url || '',
        msg.similar_products || [],
        msg.complete_the_look_embed || null
      );
    });
    messages.scrollTop = messages.scrollHeight;
  }

  toggle.addEventListener('click', () => {
    const isOpen = chatWindow.style.display === 'flex';
    setChatOpen(!isOpen);
    if (!isOpen) {
      const existingNudge = document.getElementById('kalki-nudge');
      if (existingNudge) hideNudge(existingNudge, false);
      setTimeout(() => { messages.scrollTop = messages.scrollHeight; }, 100);
      flushPendingTagalysInits();
      if (customerInfo) {
        input.focus();
      } else {
        setTimeout(() => {
          const el = document.getElementById('contact-name');
          if (el) el.focus();
        }, 100);
      }
      setTimeout(maybeShowHandsFreeCoachmark, 600);
    }
  });

  const COACHMARK_SEEN_KEY = 'kalki_hf_coachmark_seen_v1';

  function maybeShowHandsFreeCoachmark() {
    if (localStorage.getItem(COACHMARK_SEEN_KEY)) return;
    const coachmark = document.getElementById('kalki-hf-coachmark');
    const handsFreeBtn = document.getElementById('kalki-chat-handsfree');
    if (!coachmark || !handsFreeBtn || handsFreeBtn.hidden) return;
    coachmark.hidden = false;
    const closeBtn = coachmark.querySelector('.kalki-hf-coachmark-close');
    if (closeBtn) closeBtn.addEventListener('click', dismissHandsFreeCoachmark, { once: true });
    handsFreeBtn.addEventListener('click', dismissHandsFreeCoachmark, { once: true });
    setTimeout(dismissHandsFreeCoachmark, 12000);
  }

  function dismissHandsFreeCoachmark() {
    const coachmark = document.getElementById('kalki-hf-coachmark');
    if (coachmark && !coachmark.hidden) coachmark.hidden = true;
    try { localStorage.setItem(COACHMARK_SEEN_KEY, '1'); } catch (e) {}
  }

  document.getElementById('kalki-chat-close').addEventListener('click', () => {
    if (handsFreeMode) {
      handsFreeMode = false;
      if (handsFreeOps.stopListening) handsFreeOps.stopListening();
    }
    setChatOpen(false);
  });

  sendBtn.addEventListener('click', sendMessage);
  input.addEventListener('keydown', (e) => {
    if (e.key === 'Enter' && !e.shiftKey) { e.preventDefault(); sendMessage(); }
  });

  async function speakReply(text, onComplete) {
    const done = () => { handsFreeSpeaking = false; if (onComplete) onComplete(); };
    if (!text) { done(); return; }

    let clean = String(text)
      .replace(/\[OPEN_AGENT_CHAT\]/g, '')
      .replace(/\[TRIGGER_VTO\]/g, '')
      .replace(/\[OFFER_VTO\]/g, '')
      .replace(/\[OPEN_RETURN_PORTAL=[^\]]*\]/g, '') 
      // Strip Markdown formatting BEFORE the emoji pass so the TTS never
      // reads "asterisk asterisk Order Number asterisk asterisk" aloud.
      // Order matters: bold (**) before italic (*), and a final pass for
      // any orphan asterisks (e.g. from unclosed pairs).
      .replace(/\*\*(.+?)\*\*/g, '$1')   // **bold**   -> bold
      .replace(/__(.+?)__/g, '$1')       // __bold__   -> bold
      .replace(/\*(.+?)\*/g, '$1')       // *italic*   -> italic
      .replace(/`(.+?)`/g, '$1')         // `code`     -> code
      .replace(/^#{1,6}\s+/gm, '')       // # heading  -> heading
      .replace(/\*/g, '')                // orphan asterisks
      .replace(/[\u{1F300}-\u{1F9FF}]/gu, '')
      .replace(/[\u{2600}-\u{27BF}]/gu, '')
      .replace(/\n+/g, '. ')
      .replace(/\s+/g, ' ')
      .trim();

    if (!clean) { done(); return; }

    if (clean.length > HANDS_FREE_CONFIG.ttsMaxChars) {
      clean = clean.substring(0, HANDS_FREE_CONFIG.ttsMaxChars);
      const cutAt = Math.max(clean.lastIndexOf('.'), clean.lastIndexOf('!'), clean.lastIndexOf('?'));
      if (cutAt > HANDS_FREE_CONFIG.ttsMaxChars * 0.6) {
        clean = clean.substring(0, cutAt + 1);
      }
    }

    handsFreeSpeaking = true;
    setHandsFreeButtonState('speaking');

    try {
      const cloudWorked = await tryCloudTts(clean, done);
      if (cloudWorked) return;
    } catch (e) {
      console.warn('[TTS] Cloud TTS threw:', e && e.message);
    }

    console.log('[TTS] falling back to browser speechSynthesis');
    speakViaBrowser(clean, done);
  }

  async function tryCloudTts(clean, doneCallback) {
    if (!HANDS_FREE_CONFIG.cloudTtsUrl) return false;

    console.log('[TTS] requesting cloud audio: "' + clean.substring(0, 60) + '..." (' + clean.length + ' chars)');
    const tStart = Date.now();

    let response;
    try {
      response = await fetch(HANDS_FREE_CONFIG.cloudTtsUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          text: clean,
          voice: HANDS_FREE_CONFIG.cloudTtsVoice,
          language: HANDS_FREE_CONFIG.cloudTtsLanguage,
          speaking_rate: HANDS_FREE_CONFIG.ttsRate,
        }),
      });
    } catch (netErr) {
      console.warn('[TTS] cloud fetch failed:', netErr.message);
      return false;
    }

    if (!response.ok) {
      const text = await response.text().catch(() => '');
      console.warn('[TTS] cloud HTTP ' + response.status + ': ' + text.substring(0, 200));
      return false;
    }

    let data;
    try {
      data = await response.json();
    } catch (e) {
      console.warn('[TTS] cloud response not JSON');
      return false;
    }

    if (data.error || !data.audio_base64) {
      console.warn('[TTS] cloud returned error:', data.error || 'no audio');
      return false;
    }

    console.log('[TTS] cloud audio received in ' + (Date.now() - tStart) + 'ms, cached=' + (data.cached ? 'yes' : 'no'));

    if (activeTtsAudio) {
      try { activeTtsAudio.pause(); activeTtsAudio.src = ''; } catch (e) {}
      activeTtsAudio = null;
    }

    const audio = new Audio('data:audio/mp3;base64,' + data.audio_base64);
    audio.volume = 1.0;
    activeTtsAudio = audio;

    let resolved = false;
    const finish = () => {
      if (resolved) return;
      resolved = true;
      if (activeTtsAudio === audio) activeTtsAudio = null;
      doneCallback();
    };

    // CHANGE (June 2026): Immediately flip the button out of 'speaking'
    // state when audio ends so the transition to listening feels instant.
    // Without this, the button visually stays "Speaking" through the
    // autoListenDelay + startRecording handshake (~300ms+) which feels
    // sluggish even after we reduced autoListenDelayMs to 200ms.
    audio.addEventListener('ended', () => {
      console.log('[TTS] cloud playback ended');
      setHandsFreeButtonState('processing');
      finish();
    });
    audio.addEventListener('error', (e) => {
      console.warn('[TTS] cloud audio error:', e);
      setHandsFreeButtonState('processing');
      finish();
    });
    audio.addEventListener('play', () => {
      console.log('[TTS] cloud playback started');
    });

    try {
      await audio.play();
    } catch (playErr) {
      console.warn('[TTS] audio.play() rejected:', playErr.name, playErr.message);
      finish();
      return true;
    }

    setTimeout(() => {
      if (!resolved) {
        console.warn('[TTS] watchdog killing audio');
        try { audio.pause(); } catch (e) {}
        finish();
      }
    }, Math.max(20000, clean.length * 100));

    return true;
  }

  function speakViaBrowser(clean, doneCallback) {
    if (!('speechSynthesis' in window)) { doneCallback(); return; }

    try { window.speechSynthesis.cancel(); } catch (e) {}
    try { window.speechSynthesis.resume(); } catch (e) {}

    const utterance = new SpeechSynthesisUtterance(clean);
    utterance.lang = HANDS_FREE_CONFIG.ttsLangPrimary;
    utterance.rate = HANDS_FREE_CONFIG.ttsRate;
    utterance.pitch = HANDS_FREE_CONFIG.ttsPitch;
    utterance.volume = 1.0;

    const voices = window.speechSynthesis.getVoices();
    if (voices && voices.length) {
      const v = pickFemaleVoice(voices);
      if (v) utterance.voice = v;
    }

    let resolved = false;
    const finish = () => { if (!resolved) { resolved = true; doneCallback(); } };
    utterance.onstart = () => console.log('[TTS] browser fallback playing');
    // CHANGE (June 2026): Same immediate button transition as the cloud
    // path so the UX is consistent regardless of which TTS engine is used.
    utterance.onend = () => {
      setHandsFreeButtonState('processing');
      finish();
    };
    utterance.onerror = (e) => {
      console.warn('[TTS] browser fallback error:', e && e.error);
      setHandsFreeButtonState('processing');
      finish();
    };

    try {
      window.speechSynthesis.speak(utterance);
    } catch (e) {
      console.warn('[TTS] browser fallback speak threw:', e);
      finish();
      return;
    }

    setTimeout(() => {
      if (!resolved) {
        try { window.speechSynthesis.cancel(); } catch (e) {}
        finish();
      }
    }, Math.max(15000, clean.length * 90));
  }

  function pickFemaleVoice(voices) {
    const femaleNames = ['Heera', 'Kalpana', 'Zira', 'Hazel', 'Susan', 'Eva', 'Samantha', 'Karen', 'Victoria', 'Allison', 'Moira', 'Tessa', 'Veena', 'Lekha'];
    const maleNames = ['Ravi', 'Hemant', 'David', 'Mark', 'George', 'Daniel', 'Alex', 'Tom', 'Fred', 'Jorge', 'Rishi'];
    const includes = (voice, list) => list.some(n => voice.name.toLowerCase().includes(n.toLowerCase()));
    const langOrder = ['en-IN', 'hi-IN', 'en'];
    for (const lang of langOrder) {
      const match = voices.find(v => v.lang.toLowerCase().startsWith(lang.toLowerCase()) && includes(v, femaleNames));
      if (match) return match;
    }
    const explicit = voices.find(v => /female/i.test(v.name));
    if (explicit) return explicit;
    const anyFemale = voices.find(v => includes(v, femaleNames));
    if (anyFemale) return anyFemale;
    for (const lang of langOrder) {
      const fallback = voices.find(v => v.lang.toLowerCase().startsWith(lang.toLowerCase()) && !includes(v, maleNames));
      if (fallback) return fallback;
    }
    return voices[0] || null;
  }

  function startSilenceDetection(stream, onSilenceDetected) {
    const Ctx = window.AudioContext || window.webkitAudioContext;
    if (!Ctx) return null;
    let audioCtx;
    try {
      audioCtx = new Ctx();
      const source = audioCtx.createMediaStreamSource(stream);
      const analyser = audioCtx.createAnalyser();
      analyser.fftSize = 1024;
      source.connect(analyser);
      const buf = new Uint8Array(analyser.fftSize);
      let silenceStartAt = null;
      let hasHeardSpeech = false;
      let stopped = false;
      let triggered = false;
      const tick = () => {
        if (stopped || triggered) return;
        analyser.getByteTimeDomainData(buf);
        let sumSq = 0;
        for (let i = 0; i < buf.length; i++) {
          const v = (buf[i] - 128) / 128;
          sumSq += v * v;
        }
        const rms = Math.sqrt(sumSq / buf.length);
        if (rms > HANDS_FREE_CONFIG.silenceThreshold) {
          hasHeardSpeech = true;
          silenceStartAt = null;
        } else if (hasHeardSpeech) {
          if (silenceStartAt === null) {
            silenceStartAt = Date.now();
          } else if (Date.now() - silenceStartAt > HANDS_FREE_CONFIG.silenceTimeoutMs) {
            triggered = true;
            try { onSilenceDetected(); } catch (e) {}
            return;
          }
        }
        requestAnimationFrame(tick);
      };
      requestAnimationFrame(tick);
      return {
        stop: () => {
          stopped = true;
          try { audioCtx.close(); } catch (e) {}
        },
      };
    } catch (e) {
      console.warn('[HandsFree] silence detection setup failed:', e);
      if (audioCtx) try { audioCtx.close(); } catch (e2) {}
      return null;
    }
  }

  function setHandsFreeButtonState(state) {
    const btn = document.getElementById('kalki-chat-handsfree');
    if (btn) {
      btn.classList.remove('kalki-hf-listening', 'kalki-hf-speaking', 'kalki-hf-processing');
      if (state === 'listening')        btn.classList.add('kalki-hf-listening');
      else if (state === 'speaking')    btn.classList.add('kalki-hf-speaking');
      else if (state === 'processing')  btn.classList.add('kalki-hf-processing');
    }
    const pill = document.getElementById('kalki-hf-status');
    if (pill) {
      pill.classList.remove('kalki-hf-status-listening', 'kalki-hf-status-processing', 'kalki-hf-status-speaking');
      const textEl = pill.querySelector('.kalki-hf-status-text');
      if (state === 'listening') {
        pill.classList.add('kalki-hf-status-listening');
        pill.style.display = 'inline-flex';
        if (textEl) textEl.textContent = 'Listening… speak now';
      } else if (state === 'processing') {
        pill.classList.add('kalki-hf-status-processing');
        pill.style.display = 'inline-flex';
        if (textEl) textEl.textContent = 'Thinking…';
      } else if (state === 'speaking') {
        pill.classList.add('kalki-hf-status-speaking');
        pill.style.display = 'inline-flex';
        if (textEl) textEl.textContent = 'Speaking…';
      } else {
        pill.style.display = 'none';
        if (textEl) textEl.textContent = '';
      }
    }
  }

  const micBtn = document.getElementById('kalki-chat-mic');
  const VOICE_URL = 'https://api.kalkifashion.com/kalki-chat/voice-transcribe.php';

  const hasMediaRecorder = typeof MediaRecorder !== 'undefined'
    && navigator.mediaDevices
    && typeof navigator.mediaDevices.getUserMedia === 'function';

  if (hasMediaRecorder && micBtn) {
    micBtn.hidden = false;

    let mediaRecorder = null;
    let audioChunks = [];
    let activeStream = null;
    let isRecording = false;
    let recordingPurpose = 'oneshot';
    let silenceHandle = null;
    let maxRecordingTimer = null;

    function pickMimeType() {
      const candidates = ['audio/webm;codecs=opus', 'audio/webm', 'audio/ogg;codecs=opus', 'audio/mp4'];
      for (const t of candidates) {
        if (MediaRecorder.isTypeSupported && MediaRecorder.isTypeSupported(t)) return t;
      }
      return '';
    }

    // ── MIC TOOLTIP (July 2026) ─────────────────────────────────────────
    // Small auto-dismissing bubble above the mic button. Used instead of a
    // blocking alert() when no speech was captured. Appended to <body> with
    // fixed positioning so the chat window's overflow can't clip it.
    function showMicTooltip(anchorEl, text, durationMs) {
      if (!anchorEl) return;
      durationMs = durationMs || 2800;

      // Only one tooltip at a time
      const existing = document.getElementById('kalki-mic-tooltip');
      if (existing) existing.remove();

      const tip = document.createElement('div');
      tip.id = 'kalki-mic-tooltip';
      tip.textContent = text;
      tip.style.cssText =
        'position: fixed; z-index: 2147483000; max-width: 220px;' +
        'background: rgba(20, 16, 28, 0.95); color: #fff;' +
        'padding: 8px 12px; border-radius: 8px; font-size: 12.5px;' +
        'font-family: inherit; line-height: 1.4; text-align: center;' +
        'box-shadow: 0 4px 14px rgba(0,0,0,0.35);' +
        'border: 1px solid rgba(255,255,255,0.15);' +
        'opacity: 0; transform: translateY(4px);' +
        'transition: opacity 0.2s ease, transform 0.2s ease;' +
        'pointer-events: none;';
      document.body.appendChild(tip);

      // Position: centered above the mic button
      const r = anchorEl.getBoundingClientRect();
      const tw = tip.offsetWidth;
      let left = r.left + (r.width / 2) - (tw / 2);
      left = Math.max(8, Math.min(left, window.innerWidth - tw - 8));
      tip.style.left = left + 'px';
      tip.style.top = (r.top - tip.offsetHeight - 10) + 'px';

      // Little arrow pointing at the mic
      const arrow = document.createElement('div');
      arrow.style.cssText =
        'position: absolute; left: 50%; bottom: -5px; transform: translateX(-50%) rotate(45deg);' +
        'width: 10px; height: 10px; background: rgba(20, 16, 28, 0.95);' +
        'border-right: 1px solid rgba(255,255,255,0.15); border-bottom: 1px solid rgba(255,255,255,0.15);';
      tip.appendChild(arrow);

      requestAnimationFrame(() => {
        tip.style.opacity = '1';
        tip.style.transform = 'translateY(0)';
      });

      setTimeout(() => {
        tip.style.opacity = '0';
        tip.style.transform = 'translateY(4px)';
        setTimeout(() => tip.remove(), 250);
      }, durationMs);
    }

    async function startRecording(purpose) {
      recordingPurpose = (purpose === 'handsfree') ? 'handsfree' : 'oneshot';
      try {
        const stream = await navigator.mediaDevices.getUserMedia({
          audio: { echoCancellation: true, noiseSuppression: true, channelCount: 1 }
        });
        activeStream = stream;
        const mimeType = pickMimeType();
        mediaRecorder = mimeType ? new MediaRecorder(stream, { mimeType }) : new MediaRecorder(stream);
        audioChunks = [];

        mediaRecorder.ondataavailable = (e) => {
          if (e.data && e.data.size > 0) audioChunks.push(e.data);
        };

        mediaRecorder.onstop = async () => {
          if (silenceHandle) { silenceHandle.stop(); silenceHandle = null; }
          if (maxRecordingTimer) { clearTimeout(maxRecordingTimer); maxRecordingTimer = null; }
          if (activeStream) { activeStream.getTracks().forEach(t => t.stop()); activeStream = null; }

          if (recordingPurpose === 'handsfree' && !handsFreeMode) {
            console.log('[HandsFree] recording stopped after user disabled - discarding audio');
            audioChunks = [];
            resetMicState();
            setHandsFreeButtonState('idle');
            return;
          }

          if (recordingPurpose === 'handsfree') {
            setHandsFreeButtonState('processing');
          } else {
            micBtn.classList.remove('kalki-mic-listening');
            micBtn.classList.add('kalki-mic-processing');
            micBtn.setAttribute('aria-label', 'Transcribing...');
          }

          if (audioChunks.length === 0) {
            resetMicState();
            if (handsFreeMode && recordingPurpose === 'handsfree') {
              setTimeout(() => {
                if (handsFreeMode && !isRecording) startRecording('handsfree');
              }, HANDS_FREE_CONFIG.autoListenDelayMs);
            }
            return;
          }

          const blob = new Blob(audioChunks, { type: mediaRecorder.mimeType || 'audio/webm' });
          audioChunks = [];

          try {
            const transcript = await uploadAndTranscribe(blob, mediaRecorder.mimeType);

            if (recordingPurpose === 'handsfree' && !handsFreeMode) {
              console.log('[HandsFree] transcript discarded - hands-free disabled during STT');
              resetMicState();
              setHandsFreeButtonState('idle');
              return;
            }

            if (recordingPurpose === 'handsfree') {
              const trimmed = transcript ? transcript.trim() : '';
              if (trimmed && trimmed.length >= HANDS_FREE_CONFIG.minTranscriptChars) {
                input.value = trimmed;
                resetMicState();
                sendMessage();
              } else {
                console.log('[HandsFree] transcript too short, ignoring and re-listening:', JSON.stringify(trimmed));
                resetMicState();
                if (handsFreeMode) {
                  setTimeout(() => {
                    if (handsFreeMode && !isRecording) startRecording('handsfree');
                  }, HANDS_FREE_CONFIG.autoListenDelayMs);
                }
              }
            } else {
              if (transcript && transcript.trim()) {
                input.value = transcript.trim();
                input.focus();
              } else {
                showMicTooltip(micBtn, "Didn't catch that — tap the mic and try again");
              }
              resetMicState();
            }
          } catch (err) {
            console.error('🎤 Transcription failed:', err);
            if (recordingPurpose === 'handsfree') {
              resetMicState();
              if (handsFreeMode) {
                setTimeout(() => {
                  if (handsFreeMode && !isRecording) startRecording('handsfree');
                }, HANDS_FREE_CONFIG.autoListenDelayMs);
              }
            } else {
              showMicTooltip(micBtn, 'Voice search is having trouble - please type your message');
              resetMicState();
            }
          }
        };

        mediaRecorder.start();
        isRecording = true;

        if (recordingPurpose === 'handsfree') {
          setHandsFreeButtonState('listening');
          silenceHandle = startSilenceDetection(stream, () => {
            if (mediaRecorder && mediaRecorder.state !== 'inactive') {
              try { mediaRecorder.stop(); } catch (e) {}
            }
            isRecording = false;
          });
          maxRecordingTimer = setTimeout(() => {
            if (mediaRecorder && mediaRecorder.state !== 'inactive') {
              console.warn('[HandsFree] max recording duration hit - forcing stop');
              try { mediaRecorder.stop(); } catch (e) {}
              isRecording = false;
            }
          }, HANDS_FREE_CONFIG.maxRecordingMs);
        } else {
          micBtn.classList.add('kalki-mic-listening');
          micBtn.setAttribute('aria-label', 'Stop recording');
        }
      } catch (err) {
        console.error('🎤 Mic permission/access error:', err);
        if (err.name === 'NotAllowedError' || err.name === 'PermissionDeniedError') {
          alert('Microphone access blocked. Please allow microphone access in your browser settings.');
        } else if (err.name === 'NotFoundError' || err.name === 'DevicesNotFoundError') {
          alert('No microphone found on this device.');
        } else {
          alert('Could not start voice recording. Please type your message.');
        }
        if (recordingPurpose === 'handsfree') {
          handsFreeMode = false;
          setHandsFreeButtonState('idle');
        }
        resetMicState();
      }
    }

    function stopRecording() {
      if (mediaRecorder && mediaRecorder.state !== 'inactive') {
        try { mediaRecorder.stop(); } catch (e) {}
      }
      isRecording = false;
    }

    function resetMicState() {
      isRecording = false;
      micBtn.classList.remove('kalki-mic-listening');
      micBtn.classList.remove('kalki-mic-processing');
      micBtn.setAttribute('aria-label', 'Voice input');
    }

    async function uploadAndTranscribe(blob, mimeType) {
      const base64 = await new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = () => {
          const result = reader.result;
          const comma = result.indexOf(',');
          resolve(comma >= 0 ? result.substring(comma + 1) : result);
        };
        reader.onerror = reject;
        reader.readAsDataURL(blob);
      });
      const response = await fetch(VOICE_URL, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ audio_base64: base64, mime_type: mimeType || blob.type || 'audio/webm' }),
      });
      if (!response.ok) throw new Error('HTTP ' + response.status);
      const data = await response.json();
      if (data.error) throw new Error(data.error);
      return data.transcript || '';
    }

    micBtn.addEventListener('click', () => {
      if (micBtn.classList.contains('kalki-mic-processing')) return;
      if (isRecording) {
        stopRecording();
      } else {
        input.value = '';
        startRecording('oneshot');
      }
    });

    const handsFreeBtn = document.getElementById('kalki-chat-handsfree');
    if (handsFreeBtn) {
      handsFreeBtn.hidden = false;
      handsFreeOps.isReady = true;

      handsFreeOps.startListening = () => {
        if (isRecording || handsFreeSpeaking) return;
        startRecording('handsfree');
      };

      handsFreeOps.stopListening = () => {
        if (currentChatAbort) {
          try { currentChatAbort.abort(); } catch (e) {}
          currentChatAbort = null;
        }
        if (activeTtsAudio) {
          try { activeTtsAudio.pause(); activeTtsAudio.src = ''; } catch (e) {}
          activeTtsAudio = null;
        }
        try { window.speechSynthesis && window.speechSynthesis.cancel(); } catch (e) {}
        handsFreeSpeaking = false;
        if (isRecording) { try { stopRecording(); } catch (e) {} }
        if (silenceHandle) { silenceHandle.stop(); silenceHandle = null; }
        if (maxRecordingTimer) { clearTimeout(maxRecordingTimer); maxRecordingTimer = null; }
        setHandsFreeButtonState('idle');
      };

      handsFreeBtn.addEventListener('click', () => {
        if (handsFreeMode) {
          handsFreeMode = false;
          handsFreeOps.stopListening();
        } else {
          handsFreeMode = true;
          handsFreeOps.startListening();
        }
      });

      // Auto-stop hands-free when the tab is genuinely hidden (user
      // switched tabs / minimized). DEBOUNCED with a 3-second grace period
      // because:
      //
      //   1. Mic permission prompts (especially on iOS Safari and some
      //      Chrome contexts) briefly mark the tab as 'hidden' while the
      //      modal permission UI is open. Without the grace period, the
      //      handler would kill hands-free mode the moment the customer
      //      taps the nudge - before they even see the permission prompt.
      //
      //   2. Transient focus changes from other widgets (WebEngage popups,
      //      Freshmarketer, browser autofill, etc.) can also briefly hide
      //      the tab.
      //
      // If the tab returns to visible before the timer fires, the kill is
      // cancelled. If it stays hidden, hands-free cleanly shuts down.
      let visibilityKillTimer = null;
      document.addEventListener('visibilitychange', () => {
        if (document.hidden && handsFreeMode) {
          if (visibilityKillTimer) clearTimeout(visibilityKillTimer);
          visibilityKillTimer = setTimeout(() => {
            if (document.hidden && handsFreeMode) {
              console.log('[HandsFree] tab hidden for 3s - auto-stopping voice mode');
              handsFreeMode = false;
              handsFreeOps.stopListening();
            }
            visibilityKillTimer = null;
          }, 3000);
        } else if (!document.hidden && visibilityKillTimer) {
          // Tab is visible again before the kill fired - cancel it.
          // This is the path taken when the mic permission prompt closes.
          clearTimeout(visibilityKillTimer);
          visibilityKillTimer = null;
        }
      });
    }
  }

  function isClearChatRequest(msg) {
    const m = String(msg).toLowerCase().trim();
    if (m.split(/\s+/).length > 6) return false;
    const patterns = [
      /\b(clear|reset|delete|wipe|erase)\s+(my\s+|the\s+|all\s+|whole\s+)?(chat|history|conversation|messages?)\b/,
      /^clear\s+all$/,
      /^clear\s+everything$/,
      /^start\s+(over|fresh|new)$/,
      /^new\s+chat$/,
      /^reset$/,
      /^restart$/,
    ];
    return patterns.some(p => p.test(m));
  }

  // ─────────────────────────────────────────────────────────────────────
  // STORE TRIAL INTENT DETECTION (added June 2026)
  //
  // Detects when the customer's message expresses clear intent to USE
  // Store Trial / Virtual Try-On, so we can short-circuit the chat-api
  // round-trip and fire the #kalki-vto-trigger-btn button directly.
  //
  // The intercept fires when sendMessage receives matching text AND the
  // page has #kalki-vto-trigger-btn present. If the button is missing,
  // we fall through to normal chat so Aara can respond appropriately
  // (the product probably doesn't support try-on on this page).
  //
  // Detection is conservative — we explicitly reject:
  //  - Questions about Store Trial ("what is store trial?", "how does...")
  //  - Negations ("no", "don't want", "not yet", "maybe later")
  // This avoids triggering VTO when the customer is just asking ABOUT it
  // rather than asking to USE it.
  //
  // Patterns cover the exact nudge prefill ("I'd like to use Store Trial
  // for this outfit") plus common variations: "use store trial", "try
  // this on virtually", "vto", "virtual try-on", etc.
  // ─────────────────────────────────────────────────────────────────────
  function isStoreTrialRequest(msg) {
    const m = String(msg).toLowerCase().trim();

    // Length guard - direct trigger intents are typically short.
    // Longer messages are more likely styling questions or back-and-forth
    // conversation where Aara should handle it.
    if (m.length === 0 || m.length > 100) return false;

    // Question guard - questions are about Store Trial, not requests to use it.
    if (m.endsWith('?')) return false;
    if (/^(what|how|where|when|why|can|does|do|is|will|should)\b/.test(m)) return false;

    // Negation guard - explicit "no" / "later" / "not" means don't trigger.
    if (/\b(no|nope|don'?t|do\s+not|not|never|later|maybe|skip|cancel|stop)\b/.test(m)) return false;

    // Positive intent patterns
    const patterns = [
      // "use / launch / open / start store trial"
      /\b(use|launch|open|start|do|enable|begin|activate|run|show)\s+(me\s+)?(the\s+)?store\s+trial\b/,
      // "I'd / I would like to use store trial"
      /\bi'?d?\s+(would\s+)?(like|love|want)\s+(to\s+(use|do|try|see)\s+)?(the\s+)?store\s+trial\b/,
      // "I want store trial"
      /\bi\s+want\s+(to\s+)?(use\s+)?(the\s+)?store\s+trial\b/,
      // Bare command: "store trial" / "store trial please" / "store trial now"
      /^store\s+trial\s*$/,
      /^store\s+trial[\s,.!]/,
      // Virtual try-on synonyms
      /\b(virtual\s+try[-\s]?on)\b/,
      /\btry\s+(this\s+|it\s+)?on\s+(virtually|please|now)\b/,
      /^try\s+(it\s+|this\s+)?on(\s+please|\s+now)?$/,
      /^vto$/,
      // Affirmative + trial in same short message: "yes use store trial"
      /^(yes|sure|ok|okay|alright|please|yep|yeah|haan)\b.*\b(store\s+trial|try\s+on|vto|virtual)\b/,
      // July 2026 widening - production conversation needed SIX attempts:
      // "i want to tryon" (tryon joined + no 'store trial'), "i want to
      // try-on", "vertual tryon" (typo) all missed. Cover: optional intent
      // prefix + optional (typo'd) virtual + tryon/try-on/try on, with
      // optional trailing words.
      /^(i\s+want\s+(to\s+)?|i'?d\s+(like|love)\s+to\s+|let'?s\s+|please\s+)?(do\s+|use\s+|start\s+|launch\s+)?(a\s+|the\s+)?(virtual|vertual|virtaul|virtul|vitual)?\s*try[-\s]?on(\s+(this|it|now|please|product|dress|outfit))*[\s!.]*$/,
      // Bare typo'd "virtual/vertual tryon" anywhere in a short message
      /\b(virtual|vertual|virtaul|virtul|vitual)\s*try[-\s]?on\b/,
    ];
    return patterns.some(p => p.test(m));
  }

  function clearChatLocal() {
    localStorage.removeItem('kalki_chat_history');
    localStorage.removeItem('kalki_shown_product_ids');
    localStorage.removeItem('kalki_last_search');
    chatHistory = [];
    shownProductIds = [];
    lastSearch = null;
    sessionId = generateSessionId();
    localStorage.setItem('kalki_session_id', sessionId);
    messages.innerHTML = '';
    const firstName = (customerInfo && customerInfo.name) ? customerInfo.name.split(' ')[0] : 'there';
    addMessage('Chat cleared. Fresh start, ' + firstName + '! How can I help you today?', 'bot');
    input.focus();
  }

  async function sendMessage() {
    const text = input.value.trim();
    if (!text || isSending || !customerInfo) return;

    // ── STORE TRIAL INTENT INTERCEPT (added June 2026) ──────────────
    // If the customer's message clearly asks to use Store Trial AND the
    // page has the VTO trigger button, fire the button directly. No API
    // round-trip, no waiting for Aara to detect intent. Saves 1-3s of
    // latency and a token round-trip every time the nudge prefill or a
    // similar phrase is sent.
    //
    // If the button isn't on the page (product doesn't support VTO),
    // fall through to normal chat so Aara can explain or suggest
    // alternatives.
    if (isStoreTrialRequest(text)) {
      const vtoBtn = document.getElementById('kalki-vto-trigger-btn');
      if (vtoBtn) {
        console.log('[KALKI] Store Trial intent detected client-side, triggering VTO directly');
        input.value = '';

        // Show customer's message + brief acknowledgment so the chat
        // history reflects what happened. Helps continuity when the
        // customer returns to chat later.
        addMessage(text, 'user');
        chatHistory.push({ role: 'user', content: text });

        // July 2026: marker included so addMessage renders the TRY ON
        // button under the ack (persists via history for relaunching).
        // Auto-fire for this path is the setTimeout below, not the marker.
        const ackText = 'Perfect! Launching Store Trial for you now ✨ [TRIGGER_VTO]';
        addMessage(ackText, 'bot');
        chatHistory.push({ role: 'assistant', content: ackText });
        saveChatHistory();

        // Brief pause so the customer reads the ack, then close chat
        // and fire the VTO button. Delay matches the [TRIGGER_VTO]
        // pathway so the UX feels consistent (1.2s normal, 4.5s in
        // voice mode so TTS has time to speak the ack first).
        const triggerDelay = handsFreeMode ? 4500 : 1200;

        // If in hands-free, also speak the ack aloud before triggering.
        if (handsFreeMode && handsFreeOps.isReady) {
          // Use the existing TTS pipeline so voice matches normal replies.
          let resumed = false;
          const onSpeechDone = () => {
            if (!resumed) { resumed = true; triggerVtoAndCloseChat(); }
          };
          speakReply(ackText, onSpeechDone);
          // Safety: trigger anyway after the longer delay even if TTS hangs.
          setTimeout(onSpeechDone, triggerDelay);
        } else {
          setTimeout(triggerVtoAndCloseChat, triggerDelay);
        }
        return;
      }
      // Button missing - fall through to normal chat handling. Aara
      // will figure out the right response (likely "this product doesn't
      // support Store Trial, but I can help you style it...").
      console.log('[KALKI] Store Trial intent detected but #kalki-vto-trigger-btn not on page - falling through to chat');
    }

    if (isClearChatRequest(text)) {
      input.value = '';
      clearChatLocal();
      return;
    }

    isSending = true;
    sendBtn.disabled = true;
    input.value = '';

    addMessage(text, 'user');
    chatHistory.push({ role: 'user', content: text });
    saveChatHistory();

    const typingEl = addTyping();

    const requestPayload = {
      store: window.location.hostname,
      country: (() => {
        const currencyToCountry = {
            // Major world currencies
            'USD': 'US',   'EUR': 'DE',   'GBP': 'GB',   'JPY': 'JP',
            'CNY': 'CN',   'CHF': 'CH',   'CAD': 'CA',   'AUD': 'AU',
            'NZD': 'NZ',   'HKD': 'HK',   'SGD': 'SG',   'INR': 'IN',

            // South Asia
            'PKR': 'PK',   'BDT': 'BD',   'LKR': 'LK',   'NPR': 'NP',
            'AFN': 'AF',   'BTN': 'BT',   'MVR': 'MV',

            // Southeast Asia
            'MYR': 'MY',   'THB': 'TH',   'PHP': 'PH',   'IDR': 'ID',
            'VND': 'VN',   'KHR': 'KH',   'LAK': 'LA',   'MMK': 'MM',
            'BND': 'BN',

            // East Asia
            'KRW': 'KR',   'TWD': 'TW',   'MOP': 'MO',   'MNT': 'MN',

            // Middle East
            'AED': 'AE',   'SAR': 'SA',   'QAR': 'QA',   'KWD': 'KW',
            'BHD': 'BH',   'OMR': 'OM',   'JOD': 'JO',   'ILS': 'IL',
            'LBP': 'LB',   'YER': 'YE',   'IQD': 'IQ',   'SYP': 'SY',

            // Europe (non-Euro)
            'SEK': 'SE',   'NOK': 'NO',   'DKK': 'DK',   'ISK': 'IS',
            'PLN': 'PL',   'CZK': 'CZ',   'HUF': 'HU',   'RON': 'RO',
            'BGN': 'BG',   'HRK': 'HR',   'RSD': 'RS',   'MKD': 'MK',
            'BAM': 'BA',   'ALL': 'AL',   'MDL': 'MD',   'UAH': 'UA',
            'BYN': 'BY',   'RUB': 'RU',   'TRY': 'TR',   'GEL': 'GE',
            'AMD': 'AM',   'AZN': 'AZ',   'KZT': 'KZ',   'UZS': 'UZ',
            'KGS': 'KG',   'TJS': 'TJ',   'TMT': 'TM',

            // Africa
            'ZAR': 'ZA',   'EGP': 'EG',   'NGN': 'NG',   'KES': 'KE',
            'GHS': 'GH',   'MAD': 'MA',   'DZD': 'DZ',   'TND': 'TN',
            'LYD': 'LY',   'ETB': 'ET',   'UGX': 'UG',   'TZS': 'TZ',
            'RWF': 'RW',   'BIF': 'BI',   'DJF': 'DJ',   'ERN': 'ER',
            'SOS': 'SO',   'MZN': 'MZ',   'MWK': 'MW',   'ZMW': 'ZM',
            'ZWL': 'ZW',   'BWP': 'BW',   'NAD': 'NA',   'SZL': 'SZ',
            'LSL': 'LS',   'MUR': 'MU',   'SCR': 'SC',   'MGA': 'MG',
            'KMF': 'KM',   'AOA': 'AO',   'CDF': 'CD',   'XAF': 'CM',
            'XOF': 'SN',   'GMD': 'GM',   'GNF': 'GN',   'LRD': 'LR',
            'SLL': 'SL',   'CVE': 'CV',   'STN': 'ST',

            // Americas
            'MXN': 'MX',   'BRL': 'BR',   'ARS': 'AR',   'CLP': 'CL',
            'COP': 'CO',   'PEN': 'PE',   'UYU': 'UY',   'PYG': 'PY',
            'BOB': 'BO',   'VES': 'VE',   'GYD': 'GY',   'SRD': 'SR',
            'GTQ': 'GT',   'HNL': 'HN',   'NIO': 'NI',   'CRC': 'CR',
            'PAB': 'PA',   'DOP': 'DO',   'CUP': 'CU',   'HTG': 'HT',
            'JMD': 'JM',   'TTD': 'TT',   'BBD': 'BB',   'BSD': 'BS',
            'BZD': 'BZ',   'XCD': 'AG',

            // Pacific
            'FJD': 'FJ',   'PGK': 'PG',   'SBD': 'SB',   'VUV': 'VU',
            'WST': 'WS',   'TOP': 'TO'
        };
        const currency = window.Shopify?.currency?.active;
        if (currency && currencyToCountry[currency]) return currencyToCountry[currency];
        const country = window.Shopify?.country;
        if (country && /^[A-Z]{2}$/.test(country) && country !== 'AX') return country;
        return '';
      })(),
      currency_rate: (window.Shopify && window.Shopify.currency && window.Shopify.currency.rate) || 1,
      message: text,
      history: chatHistory.slice(-10),
      session_id: sessionId,
      customer_info: customerInfo,
      current_product: currentProduct,
      shown_product_ids: shownProductIds,
      last_search: lastSearch,
      voice_mode: handsFreeMode
    };

    let replyForVoice = null;

    if (currentChatAbort) {
      try { currentChatAbort.abort(); } catch (e) {}
    }
    currentChatAbort = (typeof AbortController !== 'undefined') ? new AbortController() : null;
    const abortSignal = currentChatAbort ? currentChatAbort.signal : undefined;

    try {
      const response = await fetch(API_URL, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(requestPayload),
        signal: abortSignal,
      });

      const data = await response.json();
      typingEl.remove();

      if (data.error) {
        console.error('API Error:', data.error);
        addMessage('Sorry, something went wrong. Please try again! 🙏', 'bot');
      } else {
        const reply = data.reply || "I'm here to help!";
        addMessage(reply, 'bot', data.products, data.orders, data.see_all_url, data.similar_products, data.complete_the_look_embed);
        chatHistory.push({
          role: 'assistant',
          content: reply,
          products: data.products || [],
          orders: data.orders || [],
          see_all_url: data.see_all_url || '',
          similar_products: data.similar_products || [],
          complete_the_look_embed: data.complete_the_look_embed || null
        });
        saveChatHistory();
        rememberShownProducts(data.products);
        rememberShownProducts(data.similar_products);
        if (data.last_search !== undefined) {
          rememberLastSearch(data.last_search);
        }
        replyForVoice = reply;

        // [TRIGGER_VTO] auto-fire: if Aara emits this marker tag in her
        // reply (e.g. "Great! Launching Store Trial for you... [TRIGGER_VTO]"),
        // wait briefly so the customer can read the confirmation message,
        // then close chat and click the page-level VTO button.
        //
        // Delay is 1500ms by default, or 4500ms if hands-free voice mode
        // is on (gives TTS time to speak the confirmation aloud first).
        // We do this here rather than inside addMessage so history restore
        // on page reload doesn't re-fire the trigger.
        if (typeof reply === 'string' && reply.indexOf('[TRIGGER_VTO]') !== -1) {
          const triggerDelay = handsFreeMode ? 4500 : 1500;
          console.log('[KALKI] [TRIGGER_VTO] detected in reply, firing in ' + triggerDelay + 'ms');
          setTimeout(triggerVtoAndCloseChat, triggerDelay);
        }
      }
    } catch (error) {
      if (error && error.name === 'AbortError') {
        console.log('[Chat] fetch aborted (user stopped hands-free)');
        typingEl.remove();
      } else {
        console.error('Fetch Error:', error);
        typingEl.remove();
        addMessage('Connection error. Please try again.', 'bot');
      }
    }

    currentChatAbort = null;
    isSending = false;
    sendBtn.disabled = false;
    input.focus();

    if (handsFreeMode && handsFreeOps.isReady) {
      continueHandsFreeAfterTurn(replyForVoice);
    }
  }

  function continueHandsFreeAfterTurn(reply) {
    if (!handsFreeMode) {
      setHandsFreeButtonState('idle');
      return;
    }

    const resumeListening = () => {
      if (!handsFreeMode) {
        setHandsFreeButtonState('idle');
        return;
      }
      setTimeout(() => {
        if (handsFreeMode && handsFreeOps.startListening) {
          handsFreeOps.startListening();
        } else {
          setHandsFreeButtonState('idle');
        }
      }, HANDS_FREE_CONFIG.autoListenDelayMs);
    };

    if (reply && ('speechSynthesis' in window)) {
      let resumed = false;
      const safeResume = () => { if (!resumed) { resumed = true; resumeListening(); } };
      speakReply(reply, safeResume);
      setTimeout(safeResume, 16000);
    } else {
      resumeListening();
    }
  }

  async function copyToClipboard(text) {
    if (navigator.clipboard && window.isSecureContext) {
      try { await navigator.clipboard.writeText(text); return true; } catch (e) {}
    }
    try {
      const ta = document.createElement('textarea');
      ta.value = text;
      ta.setAttribute('readonly', '');
      ta.style.position = 'fixed';
      ta.style.top = '-1000px';
      ta.style.opacity = '0';
      document.body.appendChild(ta);
      ta.select();
      ta.setSelectionRange(0, text.length);
      const ok = document.execCommand('copy');
      document.body.removeChild(ta);
      return ok;
    } catch (e) { return false; }
  }

  function selectElementText(el) {
    try {
      const range = document.createRange();
      range.selectNodeContents(el);
      const sel = window.getSelection();
      sel.removeAllRanges();
      sel.addRange(range);
    } catch (e) {}
  }

  function addMessage(text, role, products, orders, seeAllUrl, similar, completeTheLookEmbed) {
    const msgDiv = document.createElement('div');
    msgDiv.className = 'kalki-msg kalki-msg-' + role;
    const bubble = document.createElement('div');
    bubble.className = 'kalki-msg-bubble';
    const formattedText = escapeHtml(text).replace(/\n/g, '<br>');
    bubble.innerHTML = formattedText;
    msgDiv.appendChild(bubble);

    if (role === 'bot' && text.indexOf('[OPEN_RETURN_PORTAL=') !== -1) {
      const portalMatch = text.match(/\[OPEN_RETURN_PORTAL=([^\]]+)\]/);
      bubble.innerHTML = bubble.innerHTML.replace(/\[OPEN_RETURN_PORTAL=[^\]]*\]/g, '').trim();
      if (portalMatch && portalMatch[1]) {
        const portalUrl = portalMatch[1];
        const btnDiv = document.createElement('div');
        btnDiv.style.cssText = 'margin-top: 12px;';
        const btn = document.createElement('a');
        btn.textContent = 'Start Your Return →';
        btn.href = portalUrl;
        btn.target = '_blank';
        btn.rel = 'noopener';
        btn.style.cssText = 'display: inline-block; padding: 12px 24px; background: linear-gradient(135deg, #8B5CF6, #7C3AED); color: white; border: none; border-radius: 10px; font-weight: 600; cursor: pointer; font-size: 14px; text-decoration: none; transition: all 0.2s;';
        btn.onmouseover = () => btn.style.transform = 'translateY(-2px)';
        btn.onmouseout = () => btn.style.transform = 'translateY(0)';
        btnDiv.appendChild(btn);
        msgDiv.appendChild(btnDiv);
      }
    }

    if (role === 'bot' && text.includes('[OPEN_AGENT_CHAT]')) {
      bubble.innerHTML = bubble.innerHTML.replace(/\[OPEN_AGENT_CHAT\]/g, '').trim();
      const btnDiv = document.createElement('div');
      btnDiv.style.cssText = 'margin-top: 12px;';
      const btn = document.createElement('button');
      btn.textContent = 'Connect with agent';
      btn.style.cssText = 'padding: 12px 24px; background: linear-gradient(135deg, #8B5CF6, #7C3AED); color: white; border: none; border-radius: 10px; font-weight: 600; cursor: pointer; font-size: 14px; transition: all 0.2s;';
      btn.onmouseover = () => btn.style.transform = 'translateY(-2px)';
      btn.onmouseout = () => btn.style.transform = 'translateY(0)';
      btn.onclick = () => {
        if (typeof openFreshChat === 'function') {
          openFreshChat();
        } else if (typeof window.openFreshChat === 'function') {
          window.openFreshChat();
        } else {
          console.error('openFreshChat function not found');
          alert('Live chat is currently unavailable. Please try again later.');
          return;
        }
        setChatOpen(false);
      };
      btnDiv.appendChild(btn);
      msgDiv.appendChild(btnDiv);
    }

    // Strip the [TRIGGER_VTO] marker tag from the bubble so the customer
    // never sees it - and render a TRY ON button (July 2026). The AUTO
    // trigger still happens only in sendMessage's reply handler (so history
    // restore never re-fires it), but the button gives a persistent tap
    // target: relaunch after closing the VTO, or launch from restored
    // history after a page reload.
    if (role === 'bot' && (text.includes('[TRIGGER_VTO]') || text.includes('[OFFER_VTO]'))) {
      // [OFFER_VTO] (July 2026): renders the TRY ON button WITHOUT the
      // auto-launch - used when Aara OFFERS Store Trial (e.g. answering a
      // photo question) rather than the customer requesting it.
      bubble.innerHTML = bubble.innerHTML.replace(/\[TRIGGER_VTO\]/g, '').replace(/\[OFFER_VTO\]/g, '').trim();
      // July 2026: render the TRY ON button ONLY when this page can
      // actually launch Store Trial. #kalki-vto-trigger-btn exists solely
      // on try-on-enabled product pages, so this one check covers both
      // "is a PDP" and "this product supports try-on". Without it, chat
      // history restored on other pages (collections, non-VTO products)
      // showed a button that could not work there. The message text still
      // renders everywhere - only the button is page-conditional.
      if (!document.getElementById('kalki-vto-trigger-btn')) {
        // fall through - no button on pages without the VTO trigger
      } else {
      const vtoBtnDiv = document.createElement('div');
      vtoBtnDiv.style.cssText = 'margin-top: 12px;';
      const vtoBtn = document.createElement('button');
      vtoBtn.innerHTML = '<svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" style="vertical-align:-2px;margin-right:7px;" aria-hidden="true"><path d="M20.38 3.46 16 2a4 4 0 0 1-8 0L3.62 3.46a2 2 0 0 0-1.34 2.23l.58 3.47a1 1 0 0 0 .99.84H6v10c0 1.1.9 2 2 2h8a2 2 0 0 0 2-2V10h2.15a1 1 0 0 0 .99-.84l.58-3.47a2 2 0 0 0-1.34-2.23z"/></svg>TRY ON';
      vtoBtn.style.cssText = 'padding: 12px 24px; background: linear-gradient(135deg, #D4AF37, #B8860B); color: white; border: none; border-radius: 10px; font-weight: 600; cursor: pointer; font-size: 14px; letter-spacing: 0.5px; transition: all 0.2s;';
      vtoBtn.onmouseover = () => vtoBtn.style.transform = 'translateY(-2px)';
      vtoBtn.onmouseout = () => vtoBtn.style.transform = 'translateY(0)';
      vtoBtn.onclick = () => {
        if (!triggerVtoAndCloseChat()) {
          showMicTooltip(vtoBtn, 'Store Trial is not available on this page');
        }
      };
      vtoBtnDiv.appendChild(vtoBtn);
      msgDiv.appendChild(vtoBtnDiv);
      }
    }

    if (orders && orders.length > 0) {
      orders.forEach(order => {
        const orderCard = document.createElement('div');
        orderCard.className = 'kalki-order-card';
        let html = '<div class="kalki-order-header"><div><div class="kalki-order-number">Order ' + escapeHtml(order.order_number) + '</div><div class="kalki-order-date">' + escapeHtml(order.created_at) + '</div></div></div>';
        html += '<div class="kalki-order-status"><span class="kalki-status-badge status-' + order.financial_status.toLowerCase() + '">' + escapeHtml(order.financial_status) + '</span><span class="kalki-status-badge status-' + order.fulfillment_status.toLowerCase() + '">' + escapeHtml(order.fulfillment_status) + '</span></div>';
        html += '<div class="kalki-order-total">' + escapeHtml(order.total_price) + '</div><div class="kalki-order-items">';
        order.items.forEach(item => {
          html += '<div class="kalki-order-item"><span class="kalki-order-item-name">' + escapeHtml(item.title) + '</span><span class="kalki-order-item-qty">×' + item.quantity + '</span><span class="kalki-order-item-price">' + escapeHtml(item.price) + '</span></div>';
        });
        html += '</div>';
        if (order.tracking_url) {
          html += '<a href="' + escapeHtml(order.tracking_url) + '" target="_blank" class="kalki-order-track-btn">Track Order →</a>';
        }
        orderCard.innerHTML = html;
        msgDiv.appendChild(orderCard);
      });
    }

    if (products && products.length > 0) {
      const grid = document.createElement('div');
      grid.className = 'kalki-products';
      products.forEach(p => {
        const card = document.createElement('a');
        card.className = 'kalki-product-card';
        card.href = p.url;
        card.target = '_blank';
        card.rel = 'noopener';
        let cardHtml = '';
        if (p.image) cardHtml += '<img src="' + escapeHtml(p.image) + '" alt="' + escapeHtml(p.title) + '" loading="lazy">';
        cardHtml += '<div class="kalki-product-card-info"><div class="kalki-product-card-title">' + escapeHtml(p.title) + '</div><div class="kalki-product-card-price">' + escapeHtml(p.price) + '</div></div>';
        card.innerHTML = cardHtml;
        grid.appendChild(card);
      });
      msgDiv.appendChild(grid);
      if (seeAllUrl) {
        const seeAll = document.createElement('a');
        seeAll.className = 'kalki-see-all';
        seeAll.href = seeAllUrl;
        seeAll.target = '_blank';
        seeAll.rel = 'noopener';
        seeAll.textContent = 'See all results →';
        msgDiv.appendChild(seeAll);
      }
      // ── LIVE CHAT + LIVE SHOPPING quick actions (July 2026) ─────────
      // Two-column action row below "See all results". Live Chat opens
      // Freshchat on desktop (same as the Connect with agent button) and
      // WhatsApp on mobile (<=768px). Live Shopping fires the Popin
      // livestream on both. Buttons close the chat window first so the
      // opened experience isn't hidden behind it.
      const liveActions = document.createElement('div');
      liveActions.className = 'kalki-live-actions';

      const closeChatWindow = () => { setChatOpen(false); };

      const liveChatBtn = document.createElement('button');
      liveChatBtn.type = 'button';
      liveChatBtn.className = 'kalki-live-btn';
      liveChatBtn.innerHTML = '<span>Live Chat</span>';
      liveChatBtn.addEventListener('click', () => {
        const isMobile = window.matchMedia('(max-width: 768px)').matches;
        if (isMobile) {
          window.open('https://api.whatsapp.com/send/?phone=919920012474&text=Hi+Kalki+Stylist+%21&type=phone_number&app_absent=0', '_blank', 'noopener');
          return;
        }
        if (typeof openFreshChat === 'function') {
          openFreshChat();
        } else if (typeof window.openFreshChat === 'function') {
          window.openFreshChat();
        } else {
          console.error('openFreshChat function not found');
          alert('Live chat is currently unavailable. Please try again later.');
          return;
        }
        closeChatWindow();
      });

      const liveShopBtn = document.createElement('button');
      liveShopBtn.type = 'button';
      liveShopBtn.className = 'kalki-live-btn';
      liveShopBtn.innerHTML = '<span>Live Shopping</span>';
      liveShopBtn.addEventListener('click', () => {
        if (typeof Popin === 'function') {
          Popin('open');
        } else if (typeof window.Popin === 'function') {
          window.Popin('open');
        } else {
          console.error('Popin function not found');
          alert('Live shopping is currently unavailable. Please try again later.');
          return;
        }
        closeChatWindow();
      });

      liveActions.appendChild(liveChatBtn);
      liveActions.appendChild(liveShopBtn);
      msgDiv.appendChild(liveActions);
    }

    function renderSuggestionRow(heading, items) {
      if (!items || items.length === 0) return;
      const row = document.createElement('div');
      row.className = 'kalki-suggestion-row';
      const h = document.createElement('div');
      h.className = 'kalki-suggestion-heading';
      h.textContent = heading;
      row.appendChild(h);
      const scroller = document.createElement('div');
      scroller.className = 'kalki-suggestion-scroller';
      items.forEach(p => {
        const card = document.createElement('a');
        card.className = 'kalki-suggestion-card';
        card.href = p.url;
        card.target = '_blank';
        card.rel = 'noopener';
        let cardHtml = '';
        if (p.image) cardHtml += '<img src="' + escapeHtml(p.image) + '" alt="' + escapeHtml(p.title) + '" loading="lazy">';
        cardHtml += '<div class="kalki-suggestion-card-info"><div class="kalki-suggestion-card-title">' + escapeHtml(p.title) + '</div><div class="kalki-suggestion-card-price">' + escapeHtml(p.price) + '</div></div>';
        card.innerHTML = cardHtml;
        scroller.appendChild(card);
      });
      row.appendChild(scroller);
      msgDiv.appendChild(row);
    }

    renderSuggestionRow('You may also like', similar);

    if (completeTheLookEmbed && completeTheLookEmbed.widget_id) {
      renderTagalysEmbed(msgDiv, completeTheLookEmbed);
    }

    messages.appendChild(msgDiv);
    messages.scrollTop = messages.scrollHeight;
    return msgDiv;
  }
  function renderTagalysEmbed(msgDiv, embedConfig) {
    if (!embedConfig.widget_id) return;
    const wrapper = document.createElement('div');
    wrapper.className = 'kalki-suggestion-row kalki-tagalys-wrapper';
    const heading = document.createElement('div');
    heading.className = 'kalki-suggestion-heading';
    heading.textContent = embedConfig.heading || 'Complete the look';
    wrapper.appendChild(heading);
    const placeholderClass = 'kalki-tagalys-anchor-' + Date.now() + '-' + Math.floor(Math.random() * 1000);
    const placeholder = document.createElement('div');
    placeholder.className = 'kalki-tagalys-placeholder ' + placeholderClass;
    placeholder.setAttribute('data-tagalys-smart-widget', embedConfig.widget_id);
    wrapper.appendChild(placeholder);
    msgDiv.appendChild(wrapper);

    function computePlaceholderWidth() {
      const chatMessages = document.getElementById('kalki-chat-messages');
      if (!chatMessages) return 320;
      const cs = window.getComputedStyle(chatMessages);
      const padding = (parseFloat(cs.paddingLeft) || 0) + (parseFloat(cs.paddingRight) || 0);
      const usable = Math.max(chatMessages.clientWidth - padding, 240);
      const messageWidth = Math.floor(usable * 0.85);
      return Math.max(260, Math.min(messageWidth - 4, 720));
    }

    // Watchdog only starts once init has actually fired. Previously it
    // started at render time, so a deferred init (chat still closed 4s
    // after page load) would have hidden the wrapper before init ran.
    function startRenderWatchdog() {
      let cardsRendered = false;
      const observer = new MutationObserver(() => {
        const hasImage = placeholder.querySelector('img');
        const hasLink = placeholder.querySelector('a');
        const descendantCount = placeholder.querySelectorAll('*').length;
        if (hasImage || hasLink || descendantCount >= 5) {
          cardsRendered = true;
          placeholder.querySelectorAll('a').forEach(a => {
            a.setAttribute('target', '_blank');
            a.setAttribute('rel', 'noopener');
          });
        }
      });
      observer.observe(placeholder, { childList: true, subtree: true });

      setTimeout(() => {
        observer.disconnect();
        const finalHasContent = placeholder.querySelector('img') || placeholder.querySelector('a') || placeholder.querySelectorAll('*').length >= 5;
        if (!cardsRendered && !finalHasContent) {
          console.warn('[Tagalys] no content rendered after 4s, hiding wrapper');
          wrapper.style.display = 'none';
        } else {
          placeholder.querySelectorAll('a').forEach(a => {
            a.setAttribute('target', '_blank');
            a.setAttribute('rel', 'noopener');
          });
        }
      }, 4000);
    }

    function callTagalysInit() {
      try {
        if (window.Tagalys && window.Tagalys.UIWidgets && window.Tagalys.UIWidgets.SmartWidget && typeof window.Tagalys.UIWidgets.SmartWidget.init === 'function') {
          const targetWidth = computePlaceholderWidth();
          placeholder.style.width = targetWidth + 'px';
          placeholder.style.maxWidth = targetWidth + 'px';
          console.log('[Tagalys] init firing. forced width=' + targetWidth + 'px, measured=' + placeholder.offsetWidth + 'px, widget=' + embedConfig.widget_id);
          window.Tagalys.UIWidgets.SmartWidget.init('.' + placeholderClass, {
            widgetId: embedConfig.widget_id,
            templates: {
              widget: {
                options: {
                  displayFormat: 'carousel',
                  carouselOptions: { perPage: 2, duration: 250, easing: 'ease-out', draggable: true }
                }
              }
            }
          });
          startRenderWatchdog();
          [200, 600, 1200, 2000].forEach((ms) => {
            setTimeout(() => { try { window.dispatchEvent(new Event('resize')); } catch (e) {} }, ms);
          });
        } else {
          console.warn('[Tagalys] SmartWidget.init not available - widget will not render');
        }
      } catch (e) {
        console.warn('[Tagalys] init failed:', e);
      }
    }

    const chatVisible = chatWindow && chatWindow.style.display === 'flex';
    if (chatVisible) {
      requestAnimationFrame(() => { requestAnimationFrame(callTagalysInit); });
    } else {
      console.log('[Tagalys] chat window hidden - deferring init until open');
      pendingTagalysInits.push(callTagalysInit);
    }
  }

  function addTyping() {
    const msgDiv = document.createElement('div');
    msgDiv.className = 'kalki-msg kalki-msg-bot';
    msgDiv.innerHTML = '<div class="kalki-typing"><span></span><span></span><span></span></div>';
    messages.appendChild(msgDiv);
    messages.scrollTop = messages.scrollHeight;
    return msgDiv;
  }

  function saveChatHistory() {
    // Cap stored history (July 2026): entries carry full product arrays, so
    // an uncapped array grows localStorage unboundedly over weeks of use -
    // slowing the stringify on every message and eventually hitting the
    // ~5MB origin quota (which throws and would break saving entirely).
    // 60 entries ≈ 30 exchanges is far more than the UI ever restores.
    if (chatHistory.length > 60) {
      chatHistory = chatHistory.slice(-60);
    }
    try {
      localStorage.setItem('kalki_chat_history', JSON.stringify(chatHistory));
    } catch (e) {
      // Quota exceeded - drop older half and retry once.
      chatHistory = chatHistory.slice(-30);
      try { localStorage.setItem('kalki_chat_history', JSON.stringify(chatHistory)); } catch (e2) {}
    }
  }

  function validateEmail(email) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
  }

  function generateSessionId() {
    return 'chat_' + Date.now() + '_' + Math.random().toString(36).substr(2, 9);
  }

  function escapeHtml(str) {
    const div = document.createElement('div');
    div.textContent = str || '';
    return div.innerHTML;
  }
})();